import { createElement, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { useScrollReveal } from "@/hooks/useScrollReveal";

interface RevealProps {
  as?: keyof React.JSX.IntrinsicElements;
  delay?: number;
  threshold?: number;
  className?: string;
  children: ReactNode;
}

export function Reveal({ as = "div", delay = 0, threshold, className, children }: RevealProps) {
  const reveal = useScrollReveal({ threshold, delay });

  return createElement(
    as,
    {
      ref: reveal.ref,
      className: cn(reveal.className, className),
      style: reveal.style,
    },
    children,
  );
}
